export default "__VITE_PUBLIC_ASSET__be8e6e56__"